// JavaScript для heading
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для heading
});
